import { Parser } from 'expr-eval';
// let landingPositionTop;
let viewHeight;

let debug = false;

const transformExpressionRegex = /\$\{([0-9a-zA-Z\-*()/^%+]*?)}/;

const landingViewHeightSizer = function () {
    // landingPositionTop = document.querySelector('.landing-page').offsetTop;
    viewHeight = window.innerHeight;

    // this.document
    //     .querySelectorAll('.landing-sticky-view')
    //     .forEach((element) => {
    //         const el = element;
    //         el.style.height = `${viewHeight}px`;
    //     });
};

landingViewHeightSizer();

document.querySelectorAll('[data-transition]').forEach((e) => {
    e.style.cssText += e.dataset.initial;
});

const calculateLandingPositionTop = function (ell) {
    document.querySelectorAll('.landing-sticky').forEach((element) => {
        const el = element;
        const elementOffsetTop = el.offsetTop;

        const scroll = ell.srcElement.scrollTop;

        const elementHeight = element.clientHeight;

        const positionTop = scroll - elementOffsetTop;

        let position;
        if (positionTop > 0 && elementHeight === viewHeight) {
            position = positionTop / 100;
        } else if (positionTop > 0) {
            position = positionTop / (elementHeight - viewHeight);
        } else if (positionTop < 0) {
            position = positionTop / viewHeight;
        } else {
            position = 0;
        }

        if (debug === true) {
            if (el.querySelector('.log') === null) {
                const log = document.createElement('div');
                log.classList.add('log');
                el.querySelector('.landing-sticky-view').appendChild(log);
            }

            el.querySelector('.log').innerHTML = position;
        }

        el.dataset.position = position;

        /**
         * data-transition values are parsed to calculate
         * dynamic value basing on "position" variable
         * that define from -1 to 1 cycle of slide.
         *
         * Currently only "position" value is available.
         *
         * Example: data-transform='{"0.5":["translate(0, -${position*1000}px)"]}'
         */
        el.querySelectorAll('[data-transition]').forEach((e) => {
            const transitions = JSON.parse(e.dataset.transition);

            /* eslint no-restricted-syntax: ["off"] guard-for-in: ["off"] */
            for (const key in transitions) {
                const value = transitions[key];

                if (position >= key) {
                    e.style.cssText += value;
                    break;
                }
                e.style.cssText += e.dataset.initial;
            }
        });

        el.querySelectorAll('[data-transform]').forEach((e) => {
            const transforms = JSON.parse(e.dataset.transform);

            /* eslint no-restricted-syntax: ["off"] guard-for-in: ["off"] */
            for (const key in transforms) {
                if (position >= key) {
                    const values = transforms[key];

                    const parsedValues = values.map((value) => {
                        const calculations = value.replace(
                            transformExpressionRegex,
                            (_, extractedExpression) => {
                                const calculatedValue = Parser.evaluate(extractedExpression, {
                                    // minus key to have value from 0, not from start of transform
                                    position: position - key,
                                });
                                return calculatedValue;
                            }
                        );
                        return calculations;
                    });
                    // console.log('setting values', el);
                    e.style.cssText += parsedValues.join(';');
                    break;
                }
                e.style.cssText += e.dataset.initial;
            }
        });

        el.dispatchEvent(new CustomEvent('position-change', { detail: { position } }));
    });
};

document.addEventListener('scroll', calculateLandingPositionTop, true);

landingViewHeightSizer();

document.querySelectorAll('video[data-onplay]').forEach((e) => {
    const transitions = JSON.parse(e.dataset.onplay);

    e.addEventListener('play', () => {
        /* eslint no-restricted-syntax: ["off"] guard-for-in: ["off"] */
        for (const key in transitions) {
            const value = transitions[key];
            document.querySelectorAll(key).forEach((el) => el.classList.remove('d-none'));

            setTimeout(
                (passedKey, passedValue) => {
                    document.querySelectorAll(passedKey).forEach((el) => {
                        el.style.cssText += passedValue;
                    });
                },
                10,
                key,
                value
            );
        }
    });
});

export default {
    debug: (enabled = debug) => {
        debug = enabled;
    },
};
